import { GenericError } from './genericError.mjs';

/**
 * Ошибка "Неизвестная ошибка". Должна использоваться в исключительных случаях:
 *
 * @example
 * eventEmmitter.on('UncaughtException', () => {
 *  throw new UnknownError({ message: 'Event Emmitter uncaught exception!', domain: 'EventEmmiter#handler' });
 * });
 *
 * @export
 * @class UnknownError
 * @extends {GenericError}
 */
class UnknownError extends GenericError {
    constructor({ message, domain, details }) {
        super({
            type: 'UnknownError',
            message,
            domain,
            details,
        });
        Object.setPrototypeOf(this, UnknownError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, UnknownError);
        }
        else {
            this.stack = new Error().stack;
        }
    }
}

export { UnknownError };
//# sourceMappingURL=unknownError.mjs.map
